import type {Theme} from '../theme';
import {createBaseThemeVariation} from './base';

export const BusybeesTheme: Theme = createBaseThemeVariation({
    name: 'busybees',
    brandColor: 'hsla(353, 78%, 55%, 1)',
});
